import * as Sentry from "@sentry/react";
import { LogSentryException } from "@shapr3d/frontend-lib";

import { paddleVendorID } from "../config";
import type { PaddleCheckoutData } from "../types/paddleReturn";
import { LoadScript } from "./LoadScript";

declare global {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Paddle: any;
}

type PaddleCheckoutResponse = { checkout: { completed: boolean } };

export default class PaddleAdapter {
  private static instance: PaddleAdapter = new PaddleAdapter();

  static getInstance(): PaddleAdapter {
    return this.instance;
  }

  private static isPaddleLoaded = false;

  static async load() {
    if (!this.isPaddleLoaded) {
      await LoadScript({ url: "https://cdn.paddle.com/paddle/paddle.js", retry: 3 });

      if (process.env.VITE_APP_ENV !== "prod") {
        Paddle.Environment.set("sandbox");
      }
      Paddle.Setup({
        vendor: paddleVendorID,
        eventCallback: ({ event, eventData }: { event: string; eventData: PaddleCheckoutData }) => {
          if (event === "error") {
            LogSentryException({ error: new Error("Paddle error"), extra: { eventData } });
          }
        },
      });

      Sentry.setTag("paddle.version", Paddle?.Status?.libraryVersion);
    }
  }

  async openUpdatePayment(updateUrl: string): Promise<boolean> {
    await PaddleAdapter.load();
    const checkoutConfig = {
      override: updateUrl,
    };

    return new Promise((resolve, reject) => {
      try {
        Paddle.Checkout.open({
          ...checkoutConfig,
          successCallback: ({ checkout: { completed } }: PaddleCheckoutResponse) => {
            resolve(completed);
          },
          closeCallback: ({ checkout: { completed } }: PaddleCheckoutResponse) => {
            resolve(completed);
          },
        });
      } catch (err) {
        reject(err);
      }
    });
  }
}
